import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetCuratorTaxInfoRequestSchema = z
  .object({
    campaignId: z.union([z.number(), z.string()]),
    participationId: z.union([z.number(), z.string()]),
  })
  .describe('GetCuratorTaxInfoRequestSchema');

export type GetCuratorTaxInfoRequest = z.infer<typeof GetCuratorTaxInfoRequestSchema>;

const GetCuratorTaxInfoResponseDataSchema = z
  .object({
    name: z.string().describe('큐레이터 이름'),
    phone: z.string().describe('큐레이터 연락처'),
  })
  .describe('GetCuratorTaxInfoResponseDataSchema');

export type GetCuratorTaxInfoResponseData = z.infer<typeof GetCuratorTaxInfoResponseDataSchema>;

const GetCuratorTaxInfoResponseSchema = createApiResponseSchema(
  GetCuratorTaxInfoResponseDataSchema,
);

export type GetCuratorTaxInfoResponse = z.infer<typeof GetCuratorTaxInfoResponseSchema>;

export const getCuratorTaxInfo = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCuratorTaxInfoRequestSchema),
    async ({ campaignId, participationId }: GetCuratorTaxInfoRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetCuratorTaxInfoResponse>(
          partnerApiPath.getCuratorTaxInfo(campaignId, participationId),
        ),
      ),
    validateApiResponse(GetCuratorTaxInfoResponseSchema),
  ),
);
